'use strict'

Vue.component('awe-product-dropdown', {
  props: {
    products: {type: Array, default: []}, // all products
    product: {type: Object, default: null} // currently selected product
  },
  data: function(){
    return {
      expanded: false, // true to show dropdown
      selIdx: -1, // selection index
      i18n: window.i18n
    }
  },
  computed: {
    // return product list minus the selected one
    prodList: function(){
      return this.products.filter(x => x !== this.product)
    },
    currentLabel: function(){
      if (!this.product)
        return ''
      else{
        let l = this.product.name
        if (this.product.pkg)
          l += ' - ' + this.product.pkg
        return l
      }
    }
  },
  methods: {
    // show/hide dropdown list
    toggle: function(e){
      this.expanded = !this.expanded
      if (this.expanded){
        this.$el.focus()
        this.selIdx = -1
      }
    },

    select: function(e, pdt){
      if (e.type === 'mouseup' && e.which !== 1) // left-click only, right-click/wheel-click not supported
        return

      this.$root.selectProduct(pdt)
      this.expanded = false
    },

    _onmouseover: function(e, idx){
      this.selIdx = idx
    },

    onKeyDown: function(e){
      if (this.expanded)
        e.stopPropagation()

      switch(e.key){
        case 'Enter':
          if (this.expanded && this.selIdx !== -1)
            this.$root.selectProduct(this.prodList[this.selIdx])

          this.toggle()
          break
        case 'Escape':
          if (this.expanded)
            this.toggle()
          break
        case 'ArrowUp':
          if (this.expanded){
            this.selIdx = Math.max(--this.selIdx, 0)

            const pdtListNd = this.$el.getElementsByClassName('products')[0]
            const child = pdtListNd.children[this.selIdx]

            // scroll up if the selected item is above the visible area
            if (child.offsetTop < pdtListNd.scrollTop)
              pdtListNd.scrollTop -= pdtListNd.scrollTop - child.offsetTop

            e.preventDefault()
          }
          break
        case 'ArrowDown':
          if (this.expanded){
            this.selIdx = Math.min(++this.selIdx, this.prodList.length - 1)

            const pdtListNd = this.$el.getElementsByClassName('products')[0]
            const child = pdtListNd.children[this.selIdx]
            const childBottomPos = child.offsetTop - pdtListNd.scrollTop + child.clientHeight

            // scroll down if the selected item is below the visible area
            if (childBottomPos > pdtListNd.clientHeight)
              pdtListNd.scrollTop += childBottomPos - pdtListNd.clientHeight

            e.preventDefault()
          }
          break
      }
    }
  },

  template: `
    <div class="product-dropdown" v-bind:class="{expanded: expanded}" v-on:blur="expanded = false"
        v-on:keydown.up.down="onKeyDown" v-on:keyup.esc.enter="onKeyDown"
        tabindex="0" role="listbox" :aria-label="i18n.getString('SELECT_PRODUCT')"
        :aria-activedescendant="'pdt_' + selIdx"
        aria-orientation="vertical"
    >

      <div class="selection row" v-on:click="toggle" :title="product.name" :aria-label="product.name + ' '+ product.pkg">
        <slot name="selection" v-bind:product="product" v-bind:expanded="expanded">
          <div class="img-ctnr" role="presentation">
            <img loading="lazy" :src="'https://img.static-swaven.com/v7/' + encodeURIComponent(product.thumbImgUrl || product.imgUrl) + '?width=200&org_if_sml=1&ci_url_encoded=1'"
              :srcset="'https://img.static-swaven.com/v7/' + encodeURIComponent(product.thumbImgUrl || product.imgUrl) + '?width=200&org_if_sml=1&ci_url_encoded=1 1x, ' +
                      'https://img.static-swaven.com/v7/' + encodeURIComponent(product.thumbImgUrl || product.imgUrl) + '?width=300&org_if_sml=1&ci_url_encoded=1 1.5x, ' +
                      'https://img.static-swaven.com/v7/' + encodeURIComponent(product.thumbImgUrl || product.imgUrl) + '?width=400&org_if_sml=1&ci_url_encoded=1 2x, ' +
                      'https://img.static-swaven.com/v7/' + encodeURIComponent(product.thumbImgUrl || product.imgUrl) + '?width=600&org_if_sml=1&ci_url_encoded=1 3x'"
              :title="product.name" :alt="product.name">

          </div>
          <div class="info">
            {{product.name}}
          </div>
          <span class="arrow" :class="{expanded: expanded}">▼</span>
        </slot>
      </div>

      <transition name="rolldown">
        <ol v-show="expanded" class="products">
          <li v-for="(pdt, i) in prodList" class="row" :class="{hover: selIdx === i}" role="option"
            v-on:mouseup="select($event, pdt)" v-on:mousedown="$event.preventDefault()" v-on:mouseover="_onmouseover($event, i)"
            :id="'pdt_'+i"
            :aria-current="(i === selIdx).toString()"
            :aria-label="pdt.name + ' '+ pdt.pkg"
          >
                
            <slot name="option" v-bind:product="pdt">
              <div class="img-ctnr">
              <img loading="lazy" :src="'https://img.static-swaven.com/v7/' + encodeURIComponent(pdt.thumbImgUrl || pdt.imgUrl) + '?width=200&org_if_sml=1&ci_url_encoded=1'"
                :srcset="'https://img.static-swaven.com/v7/' + encodeURIComponent(pdt.thumbImgUrl || pdt.imgUrl) + '?width=200&org_if_sml=1&ci_url_encoded=1 1x, ' +
                        'https://img.static-swaven.com/v7/' + encodeURIComponent(pdt.thumbImgUrl || pdt.imgUrl) + '?width=300&org_if_sml=1&ci_url_encoded=1 1.5x, ' +
                        'https://img.static-swaven.com/v7/' + encodeURIComponent(pdt.thumbImgUrl || pdt.imgUrl) + '?width=400&org_if_sml=1&ci_url_encoded=1 2x, ' +
                        'https://img.static-swaven.com/v7/' + encodeURIComponent(pdt.thumbImgUrl || pdt.imgUrl) + '?width=600&org_if_sml=1&ci_url_encoded=1 3x'"
                :title="pdt.name" :alt="pdt.name">
              </div>
              <div class="info">{{pdt.name}}</div>
            </slot>
          </li>
        </ol>
      </transition>
      <div id="ta-announce" aria-live="polite">{{currentLabel}}</div>
    </div>
  `
})
